import { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { useNavigate } from 'react-router-dom';
import { useGetSessionContextData } from './context/PersonalDetailsContext';

export default function ConsumerPoliceCheckNextChecks() {
	const navigate = useNavigate();
	const { background_check_detail } = useGetSessionContextData();
	const [isFullscreen, setIsFullscreen] = useState(false);

	const toggleFullscreen = () => {
		const container = document.getElementById('iframe-container');
		if (!document.fullscreenElement) {
			container?.requestFullscreen().then(() => setIsFullscreen(true));
		} else {
			document.exitFullscreen().then(() => setIsFullscreen(false));
		}
	};

	return (
		<>
			<div
				className='lrpad orlight border'
				style={{ paddingBottom: '3em' }}
			>
				<h2 className='text-primary pt1'>Next Checks</h2>
				<Box
					id='iframe-container'
					sx={{
						position: 'relative',
						overflow: 'hidden',
						width: '100%',
						height: isFullscreen
							? '100vh'
							: { xs: '60vh', sm: '70vh', md: '80vh' },
						backgroundColor: 'background.paper',
						...(isFullscreen && {
							position: 'fixed',
							top: 0,
							left: 0,
							zIndex: 9999,
						}),
					}}
				>
					<IconButton
						onClick={toggleFullscreen}
						sx={{
							position: 'absolute',
							right: 10,
							top: 10,
							zIndex: 1,
							backgroundColor: 'rgba(255, 255, 255, 0.8)',
							'&:hover': {
								backgroundColor: 'rgba(255, 255, 255, 1)',
							},
						}}
						aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
					>
						{isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
					</IconButton>

					{background_check_detail?.application_url ? (
						<iframe
							title='Background Check Details'
							src={background_check_detail.application_url}
							style={{
								width: '100%',
								height: '100%',
								border: 'none',
							}}
							allowFullScreen
						/>
					) : (
						<Box
							display='flex'
							alignItems='center'
							justifyContent='center'
							height='100%'
						>
							Loading application...
						</Box>
					)}
				</Box>
			</div>
		</>
	);
}
